module.exports = __webpack_public_path__ + "img/quarterFour.4424477b.png";